import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

export const ActionPanel = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    right: 0;
    bottom: -60px;
    height: 60px;
    width: 100%;
    z-index: 100;

    transition: bottom 0.3s ease-in-out;

    ${breakpoint('laptop')`
        width: calc(100% - 290px);
    `}

    &.active {
        bottom: 0;
    }
`

export const ActionPanelContent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: 900px;
    padding: 10px;
    background-color: #fff;
    box-shadow: 0 0px 3px -1px #c7c7c7;

    p {
        margin-bottom: 0;
    }
`
